<template>
    <div>
        <main-banner v-bind:image="'src/assets/images/' + image"></main-banner>
        <h2 class="blue--text mt-5">{{$t('pages.home.about.title')}}</h2>
        <p class="mt-2 section-content" v-html="$t('pages.home.about.content')"></p>
        <h2 class="blue--text mt-5">{{$t('pages.home.clients.title')}}</h2>
        <p class="mt-2 section-content" v-html="$t('pages.home.clients.content')"></p>
        <v-layout class="row wrap mt-2">
            <v-flex class="route-card pa-3" xs12 md4 v-for="(item, index) in clients" :key="index">
                <router-link class="route-card-link" :to="item.route">
                    <v-card class="" hover>
                        <v-card-title primary-title v-bind:class="'white--text blue darken-' + (index + 1)">
                            <div>
                                <div class="headline">{{$t('pages.home.clients.elements.' + item.name + '.name')}}</div>
                            </div>
                        </v-card-title>

                        <v-card-media class="white--text" height="200px" v-bind:src="'src/assets/images/' + item.image">
                        </v-card-media>
                        <v-card-text>
                            {{$t('pages.home.clients.elements.' + item.name + '.content')}}
                        </v-card-text>
                    </v-card>
                </router-link>

            </v-flex>
        </v-layout>
    </div>
</template>
<script>
    import MainBanner from '../sections/MainBanner.vue'

    export default {
        name: 'home',
        components: {
            'main-banner': MainBanner
        },
        data() {
            return {
                image: 'home.jpg',
                clients: [{
                        name: 'pharmacies',
                        route: 'pharmacies',
                        image: 'pharmacies_1.jpg',
                        color: 'purple'
                    },
                    {
                        name: 'wholesalers',
                        route: 'wholesalers',
                        image: 'wholesalers.jpg',
                        color: 'green'
                    },
                    {
                        name: 'hospitals',
                        route: 'hospitals',
                        image: 'hospitals.jpg',
                        color: 'blue'
                    },
                ]
            };
        }
    };
</script>
<style scoped>
    a {
        text-decoration: none;
    }

  .route-card,
  .route-card>.route-card-link {
    display: inline-flex;
  }
</style>


// WEBPACK FOOTER //
// Home.vue?26b9522b